import React, { useCallback, useMemo, useState } from 'react'

import ExceptedAdsModal from './index'

export const useExceptedAdsModal = () => {
  // after successful ad creation some of the ads can still be not created and get excepted by BE
  // we need to show modal with list of excepted ads to warn user about it
  const [exceptions, setExceptions] = useState([])

  const handleAdsExceptions = useCallback(exceptions => {
    setExceptions(exceptions)
  }, [])

  return useMemo(() => {
    const hasExceptions = exceptions && exceptions.length > 0

    return {
      handleAdsExceptions,
      ExceptedAdsModal: hasExceptions ? (
        <ExceptedAdsModal
          exceptions={exceptions}
          onModalClose={() => {
            setExceptions([])
          }}
        />
      ) : null
    }
  }, [exceptions, handleAdsExceptions])
}
